import { groupHoverStyleProps } from '@/components/common/styleHelpers';
import React from 'react';
import { ArrowDown, ArrowLeft, ArrowRight, ArrowUp } from './icons';
import { LinkText, LinkTextProps } from './Typography';

interface ArrowLinkProps extends LinkTextProps {
    onClick?: () => void;
    children: React.ReactNode;
    arrowDirection?: 'up' | 'right' | 'down' | 'left';
}

export const ArrowLinkText = ({
    onClick,
    children,
    arrowDirection = 'right',
    ...props
}: ArrowLinkProps) => {
    const sharedArrowProps = {
        size: 'sm',
        style: { transition: 'all 200ms' },
    };

    return (
        <LinkText fontSize="sm" onClick={onClick} role="group" {...props}>
            {arrowDirection === 'left' && (
                <ArrowLeft
                    mr={1}
                    {...sharedArrowProps}
                    {...groupHoverStyleProps({
                        color: 'blue.400',
                        transform: 'translateX(-15%)',
                    })}
                />
            )}
            {children}
            {arrowDirection === 'right' && (
                <ArrowRight
                    ml={1}
                    {...sharedArrowProps}
                    {...groupHoverStyleProps({
                        color: 'blue.400',
                        transform: 'translateX(15%)',
                    })}
                />
            )}
            {arrowDirection === 'up' && (
                <ArrowUp
                    ml={1}
                    {...sharedArrowProps}
                    {...groupHoverStyleProps({
                        color: 'blue.400',
                    })}
                />
            )}
            {arrowDirection === 'down' && (
                <ArrowDown
                    ml={1}
                    {...sharedArrowProps}
                    {...groupHoverStyleProps({
                        color: 'blue.400',
                    })}
                />
            )}
        </LinkText>
    );
};
